import { memo } from 'react'

import NavHeader from '../../../components/navHeader/NavHeader'
import ContactLinkWrapper from './ContactLinkWrapper'

const NavHeaderWrapper = ({ contactLink, ...props }) => {
  return (
    <NavHeader {...props} contactLink={contactLink || <ContactLinkWrapper />} />
  )
}

export default memo(NavHeaderWrapper)
